export { default } from './WorldMap'
